import React, {Component} from 'react';
import ArticleImageRight from './ArticleImageRight';
import ArticleImageLeft from './ArticleImageLeft';
import ArticleImageCenter from './ArticleImageCenter';
import SplitArticle from './SplitArticle';
import ArticleImageGallery from './ArticleImageGallery';
import ArticleTable from './ArticleTable';
import Picture from '../Shared/Picture';
import PlayerYoutube from "../Shared/PlayerYoutube";

class ArticlePage extends Component {
    getImagePosition = value => {
        switch (value) {
        case "left":
            return (
                <ArticleImageLeft article={this.props.article} index={this.props.index} />
            );
            // break;
        case "right":
            return (
                <ArticleImageRight article={this.props.article} index={this.props.index} />
            );
            // break;
        case "center":
            return (
                <ArticleImageCenter article={this.props.article} index={this.props.index} />
            );
            // break;
        default:
            return (
                <ArticleImageCenter article={this.props.article} index={this.props.index} />
            );
        }
    }
    render() {
        const {
            YoutubeUrl,
            Title,
            IdForTitle,
            SecondTitle,
            ImagePosition,
            SplitImage,
            Description,
            Image,
            ImageAlt,
            ShadowColour,
            ButtonUrl,
            ButtonText,
            Id,
            teaserClass,
            ImageGallery,
            TableRows
        } = this.props.article;
        const videoClass = YoutubeUrl.Value !== "" ? "video" : "";
        return (
            <article id="section-teaser-list" className={`article-section ${videoClass}`}>

                {Title.Value !== "" ? (
                    <hgroup className="article-section-hgroup animate-ltr active">
                        <h3 id={IdForTitle ? IdForTitle.Value : null} dangerouslySetInnerHTML={{"__html": Title.Value }} className="heading3"></h3>
                    </hgroup>
                ) : null}
                {SecondTitle && SecondTitle.Value !== "" ? (
                    <hgroup className="article-section-hgroup animate-ltr active">
                        <h2 id={IdForTitle ? IdForTitle.Value : null} dangerouslySetInnerHTML={{"__html": SecondTitle.Value }}></h2>
                    </hgroup>
                ) : null}
                {ImagePosition.Value === "" && SplitImage.Value.length === 0 ? (
                    <div dangerouslySetInnerHTML={{"__html": Description.Value }}></div>
                ) : null}
                {Image.Value.length > 0 && SplitImage.Value.length === 0 && YoutubeUrl.Value === "" && ImagePosition.Value === "" ? (
                    <div className={ShadowColour.Value === "none" ? "teaser-media" : "teaser-media shadow shadow-blue"}>
                        <Picture src={Image.Value} alt={ImageAlt.Value} />
                        {ButtonUrl.Value ? <a className="buy-now-button" href={ButtonUrl.Value}>{ButtonText.Value}</a> : null}
                    </div>
                ) : null}
                {YoutubeUrl.Value !== "" ? (
                    <PlayerYoutube
                        youtubeUrl={YoutubeUrl.Value}
                        teaserId={Id}
                        teaser={this.props.article}
                        teaserClass={teaserClass}
                    />
                ) : null}
                {ImagePosition.Value ? this.getImagePosition(ImagePosition.Value) : null}
                {SplitImage.Value.length > 0 ? (
                    <SplitArticle article={this.props.article} />
                ) : null}

                {ImageGallery && ImageGallery.length > 0 ? (
                    <ArticleImageGallery article={this.props.article} />
                ) : null}
                {TableRows && TableRows.length > 0 ? (
                    <ArticleTable article={this.props.article} />
                ) : null}
            </article>
        )
    }
}

export default ArticlePage;
